import EpgPersistence from "../../../../AAF/Nepg/EpgPersistence";
import AbstractRequestTask from "../../AbstractRequestTask";
import { DOMAIN } from "../const"

class StatisticsCountryDetailsTask extends AbstractRequestTask{
	constructor(leagueId, teamViewParam, teamId, acceptLanguage = "es-ES" , version = 'v1') {
		super();
		this.leagueId = leagueId;
        this.teamViewParam = teamViewParam;
		this.acceptLanguage = acceptLanguage;
		this.version = version;
		this.teamId = teamId;
		this.params = super.getParams();
        this.user_token = this.params.user_token;
	}

	getUrl() {
		const http = "https://";
		const domain = DOMAIN
		const path = `/services/sports/${this.version}/competitions/${this.leagueId}/team-statistics`;
		return `${http}${domain}${path}`;
	}

	getParams() {
		const params = super.getParams();
		delete params.format
        delete params.api_version
        delete params.user_token
        delete params.HKS
        delete params.device_id
        delete params.device_name
        delete params.device_so
        delete params.user_id
		
		return {
			...params,
            teamId: this.teamId,
            teamView: this.teamViewParam, // statistics, lineups
			timezoneOffset: EpgPersistence.getOffset() / 60
		};
	}

	getHeaders() {
		return {
			'Authorization': `Bearer ${this.user_token}`,
			'Accept-Language': this.acceptLanguage
		}
	}

	getMethod() {
		return 'GET';
	}
}

export default StatisticsCountryDetailsTask;


// WEBPACK FOOTER //
// ./src/requests/tasks/sports/CountryDetails/statisticsCountryDetailsTask.js